// Micro animaciones — CTFit Theme

document.addEventListener('DOMContentLoaded', function () {
  var selectors = [
    '.product-card',
    '.categoria-item',
    '.objetivo-card',
    '.productos-destacados__header',
    '.por-objetivo__header',
    '.categorias-grid__header',
    '.newsletter__contenido',
    '.split-marca__contenido',
    '.pack-card',
    '.por-que__item',
    '.trust-bar__item',
    '.testimonio-card',
    '.packs__header',
    '.por-que__header',
    '.testimonios__header'
  ];

  var elements = document.querySelectorAll(selectors.join(','));

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

  elements.forEach(function (el) {
    el.classList.add('animate-on-scroll');
    observer.observe(el);
  });
});
